import { render } from "./TalentProductivityChart.vue?vue&type=template&id=722c2d6c"
import script from "./TalentProductivityChart.vue?vue&type=script&lang=js"
export * from "./TalentProductivityChart.vue?vue&type=script&lang=js"

import "./TalentProductivityChart.vue?vue&type=style&index=0&id=722c2d6c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__